import { isTauri } from './tauri';

/**
 * 외부 링크를 여는 단일 진입점.
 *
 * 데스크톱(Tauri)은 앱 WebView가 아니라 **기본 브라우저**로 연다. 앱 안에서 열리면
 * 뒤로 가기가 없어 사용자가 채팅으로 돌아올 수 없다.
 *
 * ⚠ 모듈 스코프 함수라 참조가 고정된다 — 이 함수를 쓰는 컴포넌트는 prop으로
 *   콜백을 받을 필요가 없고, 따라서 MessageItem의 memo 계약을 건드리지 않는다.
 *
 * @returns 열기를 시도했으면 true, 주소가 http(s)가 아니거나 실패하면 false
 */
export async function openExternalUrl(url: string): Promise<boolean> {
  if (!url || !/^https?:\/\//i.test(url)) return false;
  try {
    if (isTauri()) {
      const { openUrl } = await import('@tauri-apps/plugin-opener');
      await openUrl(url);
    } else {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
    return true;
  } catch {
    return false;
  }
}

const MAIL_ADDRESS_RE = /^[^\s@<>"']+@[^\s@<>"']+\.[^\s@<>"']+$/;

/**
 * 기본 메일 앱으로 새 메일 쓰기 창을 연다(프로필 모달의 메일 주소).
 * Tauri는 opener 플러그인 기본 권한(opener:default → allow-default-urls)에 `mailto:*`가 이미 있어
 * capabilities 변경이 필요 없다. openExternalUrl의 http(s) 가드는 그대로 둔다.
 *
 * @returns 열기를 시도했으면 true, 주소가 형식에 맞지 않거나 실패하면 false
 */
export async function openMailto(email: string): Promise<boolean> {
  if (!email || !MAIL_ADDRESS_RE.test(email)) return false;
  const url = `mailto:${email}`;
  try {
    if (isTauri()) {
      const { openUrl } = await import('@tauri-apps/plugin-opener');
      await openUrl(url);
    } else {
      window.location.href = url;
    }
    return true;
  } catch {
    return false;
  }
}
